import { useTranslation } from "react-i18next";

import type { PlannedOrderStatus } from "@/api/planningRun";
import { cn } from "@/lib/utils";

// The chart's marker colours, so a status reads the same in chart, timeline and label.
export const STATUS_COLOR = {
  planned: {
    dot: "bg-primary ring-primary/20",
    text: "text-primary",
    arriving: "border-l-primary",
    drawing: "border-r-primary",
  },
  firmed: {
    dot: "bg-indigo-600 ring-indigo-100",
    text: "text-indigo-600",
    arriving: "border-l-indigo-600",
    drawing: "border-r-indigo-600",
  },
  cancelled: {
    dot: "bg-slate-400 ring-slate-100",
    text: "text-slate-400",
    arriving: "border-l-slate-400",
    drawing: "border-r-slate-400",
  },
} satisfies Record<PlannedOrderStatus, Record<string, string>>;

export function OrderStatus({ status }: { status: PlannedOrderStatus }) {
  const { t } = useTranslation();
  return (
    <span className="inline-flex items-center gap-2 text-sm font-medium whitespace-nowrap">
      <span
        className={cn("size-2 rounded-full ring-3", STATUS_COLOR[status].dot)}
      />
      {t(`planningReview.status.${status}`)}
    </span>
  );
}
